// extracted by mini-css-extract-plugin
export default {"messageTitle":"styles_messageTitle__ln-na","messageSubtext":"styles_messageSubtext__ZmH5v","link":"styles_link__ulhrG"};